import BaseComponent from "../../../baseComponent.js";
import MapWidget from "../../widgets/map/mapWidget.jsx";

export default class Map extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    return (
      <MapWidget widgetId={this.props.model.id}
                   legends={this.props.model.legends}
                 togglePreloader={() => true}F
                   componentId={component.controller.id}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/map.jsx